<template>
  <div class="categories">
    <el-tabs v-model="activeName" :before-leave="prevent" @click.native="linkTo">
      <!-- <el-tab-pane label="全部分类" name="/hidden"></el-tab-pane> -->
      <el-tab-pane
        v-for="(nav, index) in navList"
        :label="nav.name"
        :key="nav.name + index"
        :name="navLink(nav)"
      ></el-tab-pane>
      <el-tab-pane label="隐藏辅助" name="/mallHomePage/goodsList"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: {
    navList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      activeName: '/mallHomePage/all'
    };
  },
  watch: {
    $route: {
      handler({ path }) {
        this.activeName = path;
      },
      immediate: true
    }
  },
  methods: {
    prevent(activeName) {
      if (
        activeName == '/mallHomePage/all' ||
        activeName == '/mallHomePage/storeList' ||
        activeName == '/mallHomePage/goodsList'
      ) {
        return true;
      } else if (activeName == '/hidden') {
        return false;
      } else {
        window.open(activeName);
        return false;
      }
    },
    linkTo() {
      const current = this.navList.find((item, index) => {
        // if (this.activeName === '/mallHomePage/all') {
        // }

        if (this.activeName.startsWith(item.ref)) {
          return {
            index,
            label: item.name
          }
        }

        return {
          index: 0,
          label: '商城首页'
        }
      })

      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-qt-sydjanB2BTAB',
        custom: {
          tabName: current.label,
          tabIndex: current.index,
        }
      })

      this.$emit('change', this.activeName);
    },
    navLink({ ref }) {
      if (!ref) {
        return '/mallHomePage/all';
      } else {
        // TODO delete
        return ref + '?' + Math.random();
      }
      // if (code == 'front') {
      //   return '/mallHomePage/all';
      // } else if (code == 'store') {
      //   return '/mallHomePage/storeList';
      // } else {
      //   return ref;
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.categories {
  ::v-deep .el-tabs__header {
    margin: 0;
  }
  ::v-deep .el-tabs__item:nth-child(2) {
    height: 48px !important;
    line-height: 48px;
    text-align: center;
    width: 192px;
    background: #1e8dff;
    color: #ffffff;
  }
  ::v-deep .el-tabs__item:last-child {
    display: none;
  }
  ::v-deep .el-tabs__item {
    box-sizing: content-box;
    min-width: 120px;
    padding: 0;
    font-size: 16px;
    text-align: center;
    & + .el-tabs__item {
      padding-left: 20px;
    }
  }
  ::v-deep .el-tabs__item + .el-tabs__item {
    padding-left: 0px;
  }
}
</style>
